import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import './context/security/login.css';
import Login from './context/security/Login';
import UserSettings from './context/user/settings';
import Layout from './context/Layout';
import NoPage from './context/NoPage';
import PrivacyPolicy from "./context/public/privacyPolicy";
import WebsitesCatalog from './context/websites/WebsitesCatalog';
import WebsiteProfile from './context/websites/WebsiteProfile';
import ClientsCatalog from './context/admin/clients/ClientsCatalog';
import Welcome from "./context/welcome/welcome";
import EntityEditor from './context/websites/internal/EntityEditor';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
     <BrowserRouter>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="/privacy-policy/:gym" element={<PrivacyPolicy />} />
        <Route path="/" element={<Layout />}> 
            <Route index element={<Welcome />} />
            <Route path="/websites" element={<WebsitesCatalog />} />
            <Route path="/websites/:id" element={<WebsiteProfile />} />
            <Route path="/websites/:id/structure/new" element={<EntityEditor />} />
            <Route path="/websites/:id/structure/:pageId/edit" element={<EntityEditor />} />
            <Route path="/clients" element={<ClientsCatalog />} />
            <Route path="/user-settings" element={<UserSettings />} />
            <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
